import type { Nationality } from '@/shared/types/api.types'
import { POPULAR_NATIONALITIES_LIMIT } from './FlowPersonalInformationWidgetQC.constants'

export const pinPopularOutboundNationalities = (nationalities: Nationality[]): Nationality[] => {
  const popular = nationalities
    .filter((nationality) => Number(nationality.popularOutbound) > 0)
    .sort((a, b) => Number(b.popularOutbound) - Number(a.popularOutbound))
    .slice(0, POPULAR_NATIONALITIES_LIMIT)

  const rest = nationalities.filter((nationality) => !popular.includes(nationality))

  return [...popular, ...rest]
}
